import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Rooms_images } from '../models/rooms_images';

@Injectable({
  providedIn: 'root'
})

export class RoomsImagesService extends CrudService<Rooms_images, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/rooms_images`);

    this._http = _http;
  }

}

